// Toutes les requêtes vers les sources passent par /p : le navigateur ne peut
// ni contourner CORS, ni écrire les en-têtes Referer et User-Agent que les
// lecteurs exigent. Le proxy repose ces en-têtes et renvoie le corps tel quel —
// à une exception près : il réécrit les manifestes HLS pour que les segments
// repassent eux aussi par lui.

export function proxyUrl(target: string, referer: string): string {
  return `/p?u=${encodeURIComponent(target)}&r=${encodeURIComponent(referer)}`;
}

export interface FetchOptions {
  referer: string;
  method?: "GET" | "POST";
  body?: string;
  contentType?: string;
  signal?: AbortSignal;
}

export async function proxyFetch(
  target: string,
  options: FetchOptions,
): Promise<Response> {
  const headers: Record<string, string> = {};

  if (options.contentType) headers["content-type"] = options.contentType;

  return fetch(proxyUrl(target, options.referer), {
    method: options.method ?? "GET",
    headers,
    body: options.body,
    signal: options.signal,
  });
}

/** Variante non fatale : une source injoignable ne doit pas faire tomber
 *  l'interface, elle rend simplement une chaîne vide. */
export async function fetchText(
  target: string,
  options: FetchOptions,
): Promise<string> {
  try {
    const res = await proxyFetch(target, options);
    if (!res.ok) return "";

    return await res.text();
  } catch {
    return "";
  }
}

export async function fetchDocument(
  target: string,
  options: FetchOptions,
): Promise<Document | null> {
  const html = await fetchText(target, options);
  if (html === "") return null;

  // Le document produit par DOMParser est inerte : aucune ressource n'est
  // chargée, aucun script n'est exécuté.
  return new DOMParser().parseFromString(html, "text/html");
}
